import { cloneElement, ReactElement } from 'react';

type Falsy = undefined | null | false;
type Props<T> = {
  when: T | Falsy;
  wrapper: ReactElement | ((children: ReactElement) => ReactElement);
  children: ReactElement;
};
export const Wrap = <T,>({ when, wrapper, children }: Props<T>): JSX.Element => {
  return when
    ? typeof wrapper === 'function'
      ? wrapper(children)
      : cloneElement(wrapper, wrapper.props, children)
    : children;
};
